import constant from './constant'
// 导入SVG文件
import docSvg from '@/icons/fileType/doc.svg'
import pdfSvg from '@/icons/fileType/pdf.svg'
import xlsxSvg from '@/icons/fileType/xlsx.svg'
import pngSvg from '@/icons/fileType/png.svg'
import zipSvg from '@/icons/fileType/zip.svg'
import htmlSvg from '@/icons/fileType/html.svg'
import mdSvg from '@/icons/fileType/md.svg'
import pptSvg from '@/icons/fileType/ppt.svg'
import wailianSvg from '@/icons/fileType/wailian.svg'
// 文件类型图标映射
const fileTypeIconMap: Record<string, string> = {
	doc: docSvg,
	docx: docSvg,
	pdf: pdfSvg,
	txt: docSvg,
	rtf: docSvg,

	xls: xlsxSvg,
	xlsx: xlsxSvg,
	csv: xlsxSvg,

	jpg: pngSvg,
	jpeg: pngSvg,
	png: pngSvg,
	gif: pngSvg,
	bmp: pngSvg,
	webp: pngSvg,

	zip: zipSvg,
	rar: zipSvg,
	'7z': zipSvg,
	tar: zipSvg,
	gz: zipSvg,

	html: htmlSvg,
	htm: htmlSvg,
	xhtml: htmlSvg,

	md: mdSvg,
	markdown: mdSvg,

	ppt: pptSvg,
	pptx: pptSvg,

	外部链接: wailianSvg,

	default: docSvg
}

/**
 * 根据文件URL或文件名获取文件类型图标
 * @param url 文件URL或文件名
 * @returns 图标路径
 */
export function getFileTypeSvg(url: string, type?: string): string {
	if (!url) {
		return fileTypeIconMap.default
	}

	// 从URL中提取文件扩展名
	const extension = type || url.split('.').pop()?.toLowerCase()

	if (!extension) {
		return fileTypeIconMap.default
	}
	if (extension == 'png' || extension == 'jpg' || extension == 'jpeg') {
		return constant.apiUrl + url
	}

	return fileTypeIconMap[extension] || fileTypeIconMap.default
}

/**
 * 根据文件URL或文件名获取文件类型
 * @param url 文件URL或文件名
 * @returns 文件类型（大写）
 */
export function getFileType(url: string): string {
	if (!url) {
		return 'DOC'
	}

	const extension = url.split('.').pop()?.toLowerCase()

	if (!extension) {
		return 'DOC'
	}

	// 特殊处理一些文件类型
	const typeMap: Record<string, string> = {
		doc: 'DOC',
		docx: 'DOCX',
		pdf: 'PDF',
		xls: 'XLS',
		xlsx: 'XLSX',
		jpg: 'JPG',
		jpeg: 'JPEG',
		png: 'PNG',
		gif: 'GIF',
		zip: 'ZIP',
		rar: 'RAR',
		html: 'HTML',
		htm: 'HTML',
		ppt: 'PPT',
		pptx: 'PPTX',
		外部链接: '外部链接'
	}

	return typeMap[extension] || extension.toUpperCase()
}

/**
 * 判断文件是否为图片类型
 * @param url 文件URL或文件名
 * @returns 是否为图片类型
 */
export function isImageFile(url: string): boolean {
	if (!url) {
		return false
	}

	const extension = url.split('.').pop()?.toLowerCase()
	const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']

	return imageExtensions.includes(extension || '')
}

/**
 * 格式化文件大小
 * @param bytes 字节数
 * @returns 格式化后的大小字符串
 */
export function formatFileSize(bytes: number): string {
	if (bytes == 0) {
		return '0 KB'
	}

	const k = 1024
	const sizes = ['KB', 'MB', 'GB', 'TB']
	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}
